import { createSvgComponent } from "../../icon/createSvgComponent";
import BookmarkFill from "@core/__generated__/icon/figma/bookmark-fill.svg";
export default createSvgComponent(BookmarkFill);